<template>
  <!-- LISTA COMENTÁRIOS -->
  <v-card
    class="mt-4 pa-2 round-corner comment-admin-container"
    elevation="0"
    outlined
    width="100%"
  >
    <p class="overline mt-3 mb-0 pl-1">Comentários</p>

    <!-- ------- NINGUEM COMENTOU ------- -->
    <v-row v-if="comentarios.length < 1" class="text-center my-4 com">
      <v-col cols="12" class="my-auto">
        <v-card
          disabled
          elevation="0"
          class="py-10 my-auto grey--text lighten-2"
        >
          Ninguém comentou neste vídeo
        </v-card>
        <!-- <v-btn
          color="primary"
          text
          block
          class="my-2 py-8"
          @click.stop="getComments(video.videoId)"
        >
          Carregar comentários...
        </v-btn> -->
      </v-col>
    </v-row>
    <!-- ----------- COMENTARAM ----------- -->
    <v-card
      v-else
      id="comment-list"
      flat
      min-height="50%"
    >
      <!-- REAL -->
      <div
        v-for="(comentario, i) in comentarios"
        :key="i"
        class="my-2 px-2 py-2 round-corner"
      >
        <p class="font-weight-bold">{{ comentario.from }} <span>{{ comentario.timestamp }}</span></p>
        <p class="pl-1 mt-1">{{ comentario.msg }}</p>
        <v-btn
          color="red"
          small
          block
          outlined
          class="mt-4"
          @click.stop="deleteComment(comentario)"
        >
          Apagar comentário
        </v-btn>
      </div>
      <!-- TESTE -->
      <!-- <div
        v-for="(comentario, i) in 15"
        :key="i"
        class="my-2 px-2 py-2 round-corner"
      >
        <p class="font-weight-bold">comentario.from<span>comentario.timestamp</span></p>
        <p class="pl-1 mt-1">comentario.msg</p>
        <v-btn
          color="red"
          small
          block
          outlined
          class="mt-4"
        >
          Apagar comentário
        </v-btn>
      </div> -->
    </v-card>
    <v-sheet class="gradient-overlay"></v-sheet>
    <!-- {{ this.video }} -->
  </v-card>
</template>

<script>
import db from '@/firebase/init'
import moment from 'moment'

export default {
  name: 'CommentsAdmin',
  // props: {
  //   video: Object,
  // },
  props: {
    id: String,
  },
  data() {
    return {
      video: null,
      comentarios: [],
    }
  },
  // computed: {
  //   comentarios: this.getComments(this.video.videoId)
  // },
  mounted() {
    //  this.getComments(this.video.videoId)
    // console.log(this.video ? JSON.parse(JSON.stringify(this.video)) : 'nada')
    // var parsedVideo = JSON.parse(JSON.stringify(this.video))
    // console.log(parsedVideo.videoId)

    // this.video ? this.getComments(parsedVideo.videoId) : console.log('nada')
    this.getVideo();
  },
  methods: {
    deleteComment(comment) {
      // console.log(comment.id)

      for (let i = 0; i < this.comentarios.length; i++) {
        // console.log('entrou aqui no for')
        // console.log(this.comentarios[i] === comment)
        if (this.comentarios[i] === comment) {
          // console.log('achei')
          this.comentarios.splice(i, 1)
        } else {
          // console.log('nao achei')
        }
      }

      let vid = db.collection('videos').doc(this.video.videoId)

      vid.collection('comments').doc(comment.id).delete().then(() => {
        // console.log("Comentário apagado com sucesso");
        alert("Comentário apagado com sucesso");
      }).catch((error) => {
        console.error("Error removing document: ", error);
      });
    },
    getComments(id){
      // console.log(id)
      let vid = db.collection('videos').doc(id)

      vid.collection('comments').orderBy("timestamp", "asc")
      .onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          // console.log(change.doc.id)
          // console.log(this.comentarios)
          if(change.type === "added"){
            let comm = change.doc.data()
            comm.id = change.doc.id
            this.comentarios.unshift(comm)
            // console.log('comentario adicionado')
            // this.updateScroll()
          }
          // if(change.type === "removed"){
          //   console.log('remova!')
          //   // let comm = change.doc.data()
          //   // console.log('esse aqui:' + comm)
          //   for (let i; i < this.comentarios.length; i++) {
          //     console.log('entrou aqui no for')
          //     if (this.comentarios[i].id === comm) {
          //       console.log('achei')
          //       this.comentarios.splice(i, 1)
          //     } else {
          //       console.log('nao achei')
          //     }
          //   }
          // }
        })
        // console.log(this.comentarios.length)
      })
    },
    getVideo(){
      db.collection('videos')
        .doc(this.id)
        .get()
        .then(doc => {
          let video = doc.data()
          video.videoId = doc.id
          if(video.display == true){
            this.getComments(doc.id)
            this.video = video
          } else{
            // this.videos.push(video)
            // console.log('Vídeo que não possui display')
          }
        })
        .catch((e) => console.error('erro ao buscar o vídeo: ', e.message))
    },
  },
  updated() {
    this.comentarios.forEach(comentario => {
      let ts = comentario.timestamp
      if (!isNaN(ts)){
        let dif = ts - this.hoje
        if(dif < 0){
          comentario.timestamp = this.getTime(ts)
        } else {
          comentario.timestamp = moment(comentario.timestamp).format('HH:mm')
        }

      }

      // console.log(ts)
    })
  }
}
</script>

<style lang="scss">
.comment-admin-container{
  overflow-y: scroll;
  -ms-overflow-style: none;
  height: min(500px, 30vh);
  max-height: 600px;
  // height: 99.5%;

  &::-webkit-scrollbar {
    display: none;
  }

  #comment-list{

    div{
      background-color: rgba($color: #30694B, $alpha: .3);
    }
    p{
      font-size: .8em;
      margin-bottom: 0px;

      span{
        font-weight: 300;
        font-size: .7em;
        float: right
      }
    }
  }
}
.gradient-overlay{
  height: 100px;
  position: sticky;
  bottom: -8px;
  left: 0;
  right: 0;
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,.0) 100%);
  &.theme--dark{
    background: linear-gradient(0deg, rgba(30,30,30,1) 0%, rgba(30,30,30,.0) 100%);
  }
}
</style>